module.exports = __webpack_public_path__ + "static/media/post_insta_03.6685ac3a.mp4";